import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import CashEntryLayer from "../../components/Accounts/CashEntryLayer";

const CashEntryPage = () => {
  return (
    <MasterLayout>
      <CashEntryLayer />
    </MasterLayout>
  );
};

export default CashEntryPage;
